import React from 'react';
import { IOrderDetailsResponse } from '../../../models/order-details';
import { IOrder } from '../../../models/purchase-history';
import { EditOrderProject } from '../../shared/edit-order-project/EditOrderProject';

interface IProjectNameCellProps {
  order: IOrder;
  orderDetails: IOrderDetailsResponse | null;
}

/**
 * Project name cell for the B2B Purchase History table (column index 4).
 *
 * Maps the row plus its resolved order details onto the shape EditOrderProject
 * needs; that component decides whether the cell shows the underlined launcher,
 * the read-only project name, or nothing at all. Before the order details
 * resolve there is no `versionId`, so the cell renders read-only until they land.
 */
export const ProjectNameCell = ({
  order,
  orderDetails,
}: IProjectNameCellProps) => (
  <EditOrderProject
    key={order?.orderNumber ?? order?.orderNumbers?.[0]}
    table
    order={{
      orderNumber: order?.orderNumber,
      orderNumbers: order?.orderNumbers,
      versionId: orderDetails?.versionId,
      // Must come from the order details, not the purchase-history row: the
      // row carries a different store number, which the editProjectName call
      // rejects. Order Details sources this the same way.
      storeNumber: orderDetails?.storeNumber,
      projectId: orderDetails?.projectId,
      // The row already carries the name, so an assigned project stays visible
      // while the details are still in flight.
      projectName: order?.projectName ?? orderDetails?.projectName,
      // Feed the cash-and-carry check the same values it read when eligibility
      // was evaluated here against the full order details response.
      orderOrigin: orderDetails?.orderOrigin,
      registerNumber: orderDetails?.registerNumber,
      transactionId: orderDetails?.transactionId,
    }}
  />
);
